import clsx from "clsx";
import { useId, type SelectHTMLAttributes } from "react";

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "id"> {
  label: string;
  hint?: string;
  options: { value: string; label: string }[];
  placeholder?: string;
}

/** Native select styled like the text field: visible label, 40 px control, Slate boundary. */
export function Select({ label, hint, options, placeholder, className, ...rest }: SelectProps) {
  const id = useId();
  return (
    <div className={clsx("flex w-full max-w-[420px] flex-col gap-2", className)}>
      <label htmlFor={id} className="text-small font-medium text-ink">
        {label}
      </label>
      <select
        id={id}
        className="min-h-10 rounded-sm border border-rule-strong bg-card px-3 py-2 text-body text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus disabled:bg-disabled disabled:text-on-disabled"
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {hint && <p className="text-small text-ink-secondary">{hint}</p>}
    </div>
  );
}
